import React from 'react';
import { Alert, Typography, Row, Col, Divider } from 'antd';
import { InfoCircleOutlined, CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

/**
 * StrictVerificationInfo
 *
 * Displays information about the strict verification rules.
 * Can be used as a collapsible alert or a dedicated info section.
 */
const StrictVerificationInfo = () => {
  return (
    <Alert
      message={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <InfoCircleOutlined />
          <Text strong>Strict Verification Rules</Text>
        </div>
      }
      description={
        <div style={{ fontSize: 13 }}>
          <Text>
            Bill verification now enforces strict matching to prevent financial errors and data inconsistencies.
          </Text>

          <Divider style={{ margin: '12px 0' }} />

          <Row gutter={[16, 12]}>
            <Col span={12}>
              <div style={{ display: 'flex', alignItems: 'start', gap: 8 }}>
                <CloseCircleOutlined style={{ color: '#ff4d4f', marginTop: 3, fontSize: 16 }} />
                <div>
                  <Text strong style={{ display: 'block', marginBottom: 4, color: '#ff4d4f' }}>
                    Blocked (Cannot Verify):
                  </Text>
                  <ul style={{ margin: 0, paddingLeft: 16, fontSize: 12 }}>
                    <li>Overcharging (rate {'>'} PO rate)</li>
                    <li>Overbilling (quantity {'>'} PO quantity)</li>
                    <li>Tax slab mismatch</li>
                    <li>Discount reduction</li>
                    <li>Calculation errors</li>
                    <li>Total mismatches</li>
                  </ul>
                </div>
              </div>
            </Col>

            <Col span={12}>
              <div style={{ display: 'flex', alignItems: 'start', gap: 8 }}>
                <CheckCircleOutlined style={{ color: '#52c41a', marginTop: 3, fontSize: 16 }} />
                <div>
                  <Text strong style={{ display: 'block', marginBottom: 4, color: '#52c41a' }}>
                    Allowed:
                  </Text>
                  <ul style={{ margin: 0, paddingLeft: 16, fontSize: 12 }}>
                    <li>Partial delivery (quantity {'<'} PO)</li>
                    <li>Better pricing (rate {'<'} PO rate)</li>
                    <li>Extra discounts</li>
                    <li>Minor rounding differences</li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>

          <Divider style={{ margin: '12px 0' }} />

          <div style={{
            padding: 10,
            background: '#f0f5ff',
            border: '1px solid #adc6ff',
            borderRadius: 4,
            fontSize: 12
          }}>
            <Text strong style={{ display: 'block', marginBottom: 6 }}>
              Tolerances:
            </Text>
            <ul style={{ margin: 0, paddingLeft: 16 }}>
              <li><strong>Rate:</strong> ±0.001 (0.1% for rounding only)</li>
              <li><strong>Quantity:</strong> No overbilling; underbilling allowed (partial delivery)</li>
              <li><strong>Tax:</strong> Exact match required</li>
              <li><strong>Discount:</strong> ±0.001% (must not be less than PO discount)</li>
              <li><strong>Amounts:</strong> ±0.50 per field, ±1.00 for totals</li>
            </ul>
          </div>

          <Text style={{ fontSize: 11, color: '#595959', display: 'block', marginTop: 12 }}>
            If verification fails, correct the bill data or reject it and request a corrected invoice from the vendor.
          </Text>
        </div>
      }
      type="info"
      closable
      style={{ marginBottom: 16 }}
    />
  );
};

export default StrictVerificationInfo;
